import Logger from '../logger';
import event from '../mixins/event';

class ThemeEventBrowser {

	// Vars
	// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

	/**
	 * Class constructor
	 */
	constructor(dom) {

		this.NAME = 'ThemeEventBrowser';

		this.dom = dom;

		this.isLoading = false;

		this.defaultDisplayType = this.dom.getAttribute('data-theme-event-browser-default-display-type');
		this.defaultEventTag = this.dom.getAttribute('data-theme-event-browser-default-event-tag');
		this.defaultEventMonth = this.dom.getAttribute('data-theme-event-browser-default-event-month');
		this.defaultEventYear = this.dom.getAttribute('data-theme-event-browser-default-event-year');

		this.month = this.defaultEventMonth;
		this.year = this.defaultEventYear;
		this.displayType = this.defaultDisplayType;

		this.browsePaneToggleDisplayDom = this.dom.querySelector(`[data-theme-event-browser-toggle-display]`);
		this.browsePaneToggleDisplayCalendarClass = 'theme-event-browser__sidebar-display-toggle--calendar';
		this.browsePaneToggleDisplayListClass = 'theme-event-browser__sidebar-display-toggle--list';

		this.eventTag = this.defaultEventTag || null;
		this.eventTagLinksDom = this.dom.querySelectorAll('[data-theme-event-browser-event-tag-link]');
		this.eventTagLinkActiveClass = 'theme-button--red';
		this.eventTagLinkInactiveClass = 'theme-button--outline';

		this.loadingClass = 'theme-event-browser--loading';

		this.previousMonthButtonDom = this.dom.querySelector('[data-theme-event-browser-previous-month]');
		this.nextMonthButtonDom = this.dom.querySelector('[data-theme-event-browser-next-month]');

		this.browsePaneActiveClass = 'theme-event-browser__browse-pane--active';
		this.calendarDom = this.dom.querySelector('[data-theme-event-browser-calendar]');
		this.listPaneDom = this.dom.querySelector('[data-theme-event-browser-display-type="list"]');
		this.calendarPaneDom = this.dom.querySelector('[data-theme-event-browser-display-type="calendar"]');
		this.listItemsDom = this.dom.querySelector('[data-theme-event-browser-list-items]');
		this.monthDom = this.dom.querySelector('[data-theme-event-browser-month]');

	}

	/**
	 * init - Initialize the component
	 **/
	init() {
		Logger.info(`${this.NAME} > init`);

		this.setLoadingState(false);

		// Get the current month and year
		if (!this.defaultEventMonth) {
			this.month = new Date().getMonth() + 1;
		}
		if (!this.defaultEventYear) {
			this.year = new Date().getFullYear();
		}

		this.initPreviousMonthButton();
		this.initNextMonthButton();
		this.initTagLinks();
		this.initBrowsePaneToggleDisplay();

		this.fetchEvents();
	}

	/**
	 * fetchEvents - Fetch the events
	 */
	async fetchEvents() {
		Logger.info(`${this.NAME} > fetchEvents`);

		if (this.isLoading) return;

		this.setLoadingState(true);

		this.setUrlState();

		this.renderMonth();

		setTimeout(async () => {

			var formData = new FormData();

			formData.append('action', 'wonder_get_event_browser_items');
			formData.append('nonce', window.global_vars.ajax_nonce);
			formData.append('tag', this.eventTag);
			formData.append('month', this.month);
			formData.append('year', this.year);

			const url = `${window.global_vars.ajax_url}`;

			// Fetch from wp-admin
			const response = await fetch(url, {
				method: 'POST',
				body: formData,
			});
			const data = await response.json();
			this.renderEvents(data);
			this.setPresentationState();

			this.setLoadingState(false);

			return data;
		}, 300);
	}

	/**
	 * initNextMonthButton - Initialize the next month button
	 */
	initNextMonthButton() {
		Logger.info(`${this.NAME} > initNextMonthButton`);

		if (this.nextMonthButtonDom) {
			this.nextMonthButtonDom.addEventListener('click', () => {
				this.month++;
				if (this.month > 12) {
					this.month = 1;
					this.year++;
				}
				this.fetchEvents();
			});
		}
	}

	/**
	 * initPreviousMonthButton - Initialize the previous month button
	 */
	initPreviousMonthButton() {
		Logger.info(`${this.NAME} > initPreviousMonthButton`);

		if (this.previousMonthButtonDom) {
			this.previousMonthButtonDom.addEventListener('click', () => {
				this.month--;
				if (this.month < 1) {
					this.month = 12;
					this.year--;
				}
				this.fetchEvents();
			});
		}
	}

	/**
	 * initTagLinks - Initialize the tag links
	 */
	initTagLinks() {
		Logger.info(`${this.NAME} > initTagLinks`);

		if (this.eventTagLinksDom) {
			this.eventTagLinksDom.forEach((eventTagLink) => {
				eventTagLink.addEventListener('click', (e) => {
					e.preventDefault();
					this.eventTag = eventTagLink.getAttribute('data-theme-event-browser-event-tag-link');
					if ('all' === this.eventTag) {
						this.eventTag = null;
					}
					this.fetchEvents();
				});
			});
		}
	}

	/**
	 * initBrowsePaneToggleDisplay - Initialize the browse pane toggle display
	 */
	initBrowsePaneToggleDisplay() {
		Logger.info(`${this.NAME} > initBrowsePaneToggleDisplay`);
		this.browsePaneToggleDisplayDom.addEventListener(`click`, (e) => {
			e.preventDefault();
			this.toggleDisplay();
		});
	}

	/**
	 * renderEvents - Render the events
	 */
	renderEvents(data) {
		Logger.info(`${this.NAME} > renderEvents`);

		if (this.calendarDom) {
			this.calendarDom.innerHTML = data.calendar_html;
		}

		if (this.listItemsDom) {
			this.listItemsDom.innerHTML = data.list_html;
		}
	}

	/**
	 * renderMonth - Render the month
	 */
	renderMonth() {
		Logger.info(`${this.NAME} > renderMonth`);

		if (this.monthDom) {
			const monthName = new Date(this.year, this.month - 1).toLocaleString('en-US', { month: 'long' });
			const year = new Date(this.year, this.month - 1).getFullYear();
			this.monthDom.innerHTML = `${monthName} ${year}`;
		}
	}

	/**
	 * setLoadingState - Set the loading state
	 */
	setLoadingState(isLoading = true) {
		Logger.info(`${this.NAME} > setLoadingState`);
		this.isLoading = isLoading;
		if (this.isLoading) {
			this.dom.classList.add(this.loadingClass);
		} else {
			this.dom.classList.remove(this.loadingClass);
		}
		return this.isLoading;
	}

	/**
	 * setPresentationState - Set the presentation state
	 */
	setPresentationState() {
		Logger.info(`${this.NAME} > setPresentationState`);

		// Set the active class to the clicked event tag link
		this.eventTagLinksDom.forEach((eventTagLink) => {
			if (eventTagLink.getAttribute(`data-theme-event-browser-event-tag-link`) === this.eventTag || (this.eventTag === null && eventTagLink.getAttribute(`data-theme-event-browser-event-tag-link`) === 'all')) {
				eventTagLink.classList.add(this.eventTagLinkActiveClass);
				eventTagLink.classList.remove(this.eventTagLinkInactiveClass);
			} else {
				eventTagLink.classList.remove(this.eventTagLinkActiveClass);
				eventTagLink.classList.add(this.eventTagLinkInactiveClass);
			}
		});
	}

	/**
	 * setUrlState - Set the url state
	 */
	setUrlState() {
		Logger.info(`${this.NAME} > setUrlState`);
		const url = new URL(window.location.href);

		if (this.eventTag) {
			url.searchParams.set('event_tag', this.eventTag);
		} else {
			url.searchParams.delete('event_tag');
		}

		if (this.month) {
			url.searchParams.set('event_month', this.month);
		} else {
			url.searchParams.delete('event_month');
		}

		if (this.year) {
			url.searchParams.set('event_year', this.year);
		} else {
			url.searchParams.delete('event_year');
		}

		if (this.displayType) {
			url.searchParams.set('display_type', this.displayType);
		} else {
			url.searchParams.set('display_type', 'list');
		}

		window.history.pushState({}, '', url.toString());
		return url.toString();
	}

	/**
	 * showListPane - Show the list pane
	 */
	showListPane() {
		Logger.info(`${this.NAME} > showListPane`);
		this.displayType = 'list';
		this.listPaneDom.classList.add(this.browsePaneActiveClass);
		this.calendarPaneDom.classList.remove(this.browsePaneActiveClass);
		this.browsePaneToggleDisplayDom.parentNode.classList.remove(this.browsePaneToggleDisplayCalendarClass);
		this.browsePaneToggleDisplayDom.parentNode.classList.add(this.browsePaneToggleDisplayListClass);
		this.setUrlState();
	}

	/**
	 * showCalendarPane - Show the calendar pane
	 */
	showCalendarPane() {
		Logger.info(`${this.NAME} > showCalendarPane`);
		this.displayType = 'calendar';
		this.calendarPaneDom.classList.add(this.browsePaneActiveClass);
		this.listPaneDom.classList.remove(this.browsePaneActiveClass);
		this.browsePaneToggleDisplayDom.parentNode.classList.remove(this.browsePaneToggleDisplayListClass);
		this.browsePaneToggleDisplayDom.parentNode.classList.add(this.browsePaneToggleDisplayCalendarClass);
		this.setUrlState();
	}

	/**
	 * toggleDisplay - Toggle the display
	 */
	toggleDisplay() {
		Logger.info(`${this.NAME} > toggleDisplay`);
		if (this.listPaneDom.classList.contains(this.browsePaneActiveClass)) {
			this.showCalendarPane();
		} else {
			this.showListPane();
		}
	}

}

Object.assign(ThemeEventBrowser.prototype, event);

export default ThemeEventBrowser;
